import { useState, useCallback } from 'react';

export default function LikeButton({ liked, count, onToggle }) {
  const [animating, setAnimating] = useState(false);

  const handleClick = useCallback(() => {
    if (!liked) setAnimating(true);
    onToggle();
  }, [liked, onToggle]);

  return (
    <button
      className={`like-btn ${liked ? 'liked' : ''} ${animating ? 'heartbeat' : ''}`}
      onClick={handleClick}
      onAnimationEnd={() => setAnimating(false)}
    >
      <svg viewBox="0 0 24 24" className="heart-icon" width="20" height="20">
        <path
          d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
          fill={liked ? 'var(--accent)' : 'none'}
          stroke={liked ? 'var(--accent)' : 'var(--text-secondary)'}
          strokeWidth="2"
        />
      </svg>
      <span className="like-count">{count || ''}</span>
    </button>
  );
}
